import { GameLaunchInfoRequest, GameReplayUrlRequest, GameReplayUrlResponse, HTTPResponse, LaunchData, TopWinnersRequest, VirtualGamesRequest, TopWin, VirtualGame } from '../../../models';
import { BaseApiService } from '../../base-api-service';
import { env } from '../../../environment';

class GameController extends BaseApiService {

  public async getLaunchData(launchToken: string): Promise<HTTPResponse<LaunchData | null>> {
    const url = `${this.url}/api/launch/info`;
    return await this.http.get(url, { params: { launchToken }, skipInterceptor: true });
  }

  public async getGameLaunchInfo(params: GameLaunchInfoRequest): Promise<Partial<LaunchData>> {
    const url = `${this.url}/api/games/launchInfo`;
    return await this.http.get(url, { params });
  }

  public async getVirtualGames(params: VirtualGamesRequest): Promise<Array<VirtualGame>> {
    const url = `${this.url}/api/games/virtualGames`;
    return await this.http.get(url, { params });
  }

  public async getTopWinners(params: TopWinnersRequest): Promise<Array<TopWin>> {
    const url = `${this.url}/api/statistics/topWinners`;
    return await this.http.get(url, { params });
  }

  public async getGameReplayUrl(gameId: number, params: GameReplayUrlRequest): Promise<GameReplayUrlResponse> {
    const url = `${this.url}/api/games/${gameId}/replay`;
    return await this.http.get(url, { params });
  }

}

export const gameController = new GameController({ url: env.origin });
